import { render, staticRenderFns } from "./AwardList.vue?vue&type=template&id=5b138ff8"
import script from "./AwardList.vue?vue&type=script&lang=ts"
export * from "./AwardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports